import { useEffect, useState } from 'react';

import { environment } from '@anyx/app-core/env';

import { useNotificationsUnreadCount } from '@anyx/common-notification';
import { useSelfCtx } from '@anyx/common-self';

export const useUnreadCount = ({ skip }: { skip?: boolean }) => {
  const {
    self: { id, accountIds },
  } = useSelfCtx();
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(false);
  const { getUnreadNotificationsCount } = useNotificationsUnreadCount({
    userId: id,
    accountId: accountIds[0],
    skip,
  });

  useEffect(() => {
    setLoading(true);
    let unsubscribe: (() => void) | undefined;
    try {
      unsubscribe = getUnreadNotificationsCount((count) => {
        setUnread(count);
      });
    } catch (err) {
      if (environment.enableDebug) {
        console.error('Failed to load unread count:', err);
      }
    } finally {
      setLoading(false);
    }

    return () => unsubscribe?.();
  }, [getUnreadNotificationsCount]);

  return { unread, loading };
};
